import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const tableRow = ({ palette, spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiTableRow"] => ({
    root: {
        borderBottom: `1px solid ${palette.grey40}`,
    },
    head: {
        lineHeight: spacing(3),
        borderBottom: `1px solid ${palette.grey40}`,
    },
});

export default tableRow;
